<div class="row principalDarkerBackground centrado fullHeight">
  <div class="card width90 ">
    <div class="card-container">
      <div class="row ">
        <div class="col-md-12 ">
          <img src="assets/images/logo.png" class="imgLogoXS">
        </div>
        <div class="col-md-12 padding10">
          <img class="selfie"
               [src]="imageSelfie" />
        </div>
        <div class="col-md-12 padding30">
          <h3 class="colorPrincipal">Estado Enrolamiento : {{enrollStatus}}</h3>
        </div>
      </div>

      <div class="container ">
        <div class="row ">
          <div class="col-5">
            <p class="colorPrincipal  "> Nombre</p>
          </div>
          <div class="col-2">
            <p class="colorSecundario  "> |</p>
          </div>
          <div class="col-5">
            <p class="colorSecundario  "> {{names}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <p class="colorPrincipal  "> Apellidos</p>
          </div>
          <div class="col-2">
            <p class="colorSecundario  "> |</p>
          </div>
          <div class="col-5">
            <p class="colorSecundario  "> {{surnames}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <p class="colorPrincipal  "> Documento</p>
          </div>
          <div class="col-2">
            <p class="colorSecundario  "> |</p>
          </div>
          <div class="col-5">
            <p class="colorSecundario  "> {{number}}</p>
          </div>
        </div>
        <div class="row ">
          <div class="col-5">
            <a class="nav-link botonID principalBackground padding10">
                </a>
          </div>
          <div class="col-2">
            <p class="colorSecundario  ">  </p>
          </div>
          <div class="col-5">
            <a class="nav-link botonID principalBackground padding10">
                </a>
          </div>
        </div>
      </div>

      <div class="row centrado">
        <div class="col-md-12 ">
          <a routerLink="/frontID"> <img class="finalButton principalBackground padding10"
                                         src="assets/images/idnow_back_action_icon@2x.png" />
            <p class="colorSecundario fontItalic">Reiniciar <br> Enrolamiento</p></a>
        </div>
        <div class="col-md-12 ">
          <img src="assets/images/logo.png" class="imgLogoXS">

        </div>
      </div>
    </div>

  </div>
</div>
